<app-modal
  [title]="titleKey"
  [closeText]="'CANCEL'"
  [submitText]="submitTextKey"
  (submitClicked)="modalRef.close(true)">
  <p class="mb-0">{{ messageKey | translate: { name: userName, count: ownedMailAccounts.length } }}</p>

  @if (showOwnedMailAccountsWarning) {
    <div class="alert alert-danger fw-bold mt-3 mb-2" role="alert">
      {{ 'ADMIN.USERS.DELETE_CONFIRM_OWNED_MAIL_ACCOUNTS_WARNING' | translate }}
    </div>
    <p class="mb-1 fw-semibold">{{ 'ADMIN.USERS.DELETE_CONFIRM_OWNED_MAIL_ACCOUNTS_LIST_TITLE' | translate }}</p>
    <ul class="mb-0 ps-3">
      @for (mailAccount of ownedMailAccounts; track mailAccount.id) {
        <li>{{ mailAccount.name || ('ADMIN.MAIL_ACCOUNTS.TITLE' | translate) + ' #' + mailAccount.id }}</li>
      }
    </ul>
  }
</app-modal>
